import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet
} from '@react-pdf/renderer';
import { useStore } from '../../../app/stores/Store';

// Create styles
const styles = StyleSheet.create({
    title: {
        fontSize: 24,
        textAlign: 'center',
    },
    pageHeading: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    image: {
        padding: '15px',
        width: '150px'
    },
    documentHeading: {
        padding: '15px',
        marginRight: '20px',
        fontSize: 20,
        fontWeight: 'bold'
    },
    table: {
        padding: 15,
        width: '100%',
        marginTop: 20,
        marginBottom: 8,
    },
    break: {
        flexBasis: 100,
        height: 0
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '2px solid #EEE',
        border: 1
    },
    header: {
        borderTop: 'none',
        marginTop: '10px'
    },
    heading: {
        padding: '5px',
        fontWeight: 'bold',
        fontSize: 16
    },
    bold: {
        fontWeight: 'bold',
    },
    smallText: {
        fontSize: 10,
        fontStyle: 'italic',
    },
    col1: {
        fontSize: 12,
        width: '5%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'
    },
    col2: {
        fontSize: 12,
        width: '30%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col3: {
        fontSize: 12,
        width: '10%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col4: {
        fontSize: 12,
        width: '10%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col5: {
        fontSize: 12,
        width: '10%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col6: {
        fontSize: 12,
        width: '10%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col7: {
        fontSize: 12,
        width: '10%',
        textAlign: 'center',
        borderLeft: 1,
        padding: '2px'

    },
    col8: {
        fontSize: 12,
        width: '15%',
        textAlign: 'center',
        borderLeft: 1,
        borderRight: 1,
        padding: '2px'
    }
})
const PdfDocument = (): any => {
    const { costingStore } = useStore();
    const { quotes } = costingStore;

    const GetRounded = (value: number) => {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }

    const GetQuantity = (index: number) => {
        const damper = quotes[index];
        if (damper.quantity !== '') {
            return Number.parseInt(damper.quantity);
        } else {
            return 0;
        }
    }
    return React.createElement(
        Document as any,
        {},
        React.createElement(
            Page as any,
            { size: "A4", style: styles.page },
            React.createElement(
                View as any,
                { style: styles.pageHeading },
                React.createElement(Image as any, {
                    style: styles.image,
                    src: "/assets/logo.png"
                }),
                React.createElement(Text as any, { style: styles.documentHeading }, "Quotes")
            ),
            React.createElement(
                View as any,
                { style: styles.table },
                React.createElement(
                    View as any,
                    { style: [styles.row, styles.bold, styles.header] },
                    React.createElement(Text as any, { style: [styles.col1, styles.heading] }, "Id"),
                    React.createElement(Text as any, { style: [styles.col2, styles.heading] }, "Product"),
                    React.createElement(Text as any, { style: [styles.col3, styles.heading] }, "Mat"),
                    React.createElement(Text as any, { style: [styles.col4, styles.heading] }, "Lab"),
                    React.createElement(Text as any, { style: [styles.col5, styles.heading] }, "OH"),
                    React.createElement(Text as any, { style: [styles.col6, styles.heading] }, "Cost"),
                    React.createElement(Text as any, { style: [styles.col7, styles.heading] }, "Qty"),
                    React.createElement(Text as any, { style: [styles.col8, styles.heading] }, "Total")
                ),
                quotes.map((myquote, i) =>
                    React.createElement(
                        View as any,
                        { key: i, style: styles.row, wrap: false },
                        React.createElement(
                            Text as any,
                            { style: styles.col1 },
                            React.createElement(Text as any, { style: styles.bold }, i + 1)
                        ),
                        React.createElement(
                            Text as any,
                            { style: styles.col2 },
                            React.createElement(Text as any, { style: styles.bold }, myquote.selectedProduct),
                            "\n",
                            React.createElement(Text as any, { style: styles.smallText }, `${myquote.width} x ${myquote.height}`)
                        ),
                        React.createElement(
                            Text as any,
                            { style: styles.col3 },
                            React.createElement(Text as any, { style: styles.bold }, GetRounded(myquote.totalMaterialCost)),
                            "\n",
                            React.createElement(Text as any, { style: styles.smallText }, `${myquote.totalMaterialPercentage}%`)
                        ),
                        React.createElement(
                            Text as any,
                            { style: styles.col4 },
                            React.createElement(Text as any, { style: styles.bold }, GetRounded(myquote.totalLaborCost)),
                            " ",
                            "\n",
                            React.createElement(Text as any, { style: styles.smallText }, `${myquote.totalLaborPercentage}%`)
                        ),
                        React.createElement(
                            Text as any,
                            { style: styles.col5 },
                            React.createElement(Text as any, { style: styles.bold }, GetRounded(myquote.totalOverheads)),
                            "\n",
                            React.createElement(Text as any, { style: styles.smallText }, `${myquote.totalOverheadPercentage}%`)
                        ),
                        React.createElement(Text as any, { style: styles.col6 }, `$ ${GetRounded(myquote.totalCost)}`),
                        React.createElement(Text as any, { style: styles.col7 }, GetQuantity(i)),
                        React.createElement(Text as any, { style: styles.col8 }, `$ ${GetRounded(myquote.totalCost) * GetQuantity(i)}`)
                    )
                )
            )
        )
    )
}

export default PdfDocument